import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useBreakpoint } from '~/composables';
import ProductSeriesGallery from '~/components/sections/productSection/ProductSeriesGallery.vue';

interface Props {
  product?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSeries',
  props: {
    product: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { product: any };



const { isBiggerThanBreakpoint: isBiggerSm } = useBreakpoint('sm');

const similarProducts = computed(() =>
  props.product?.similar_products?.[0]?.items
    ?.filter((item: any) => item.active)
    .map((item: any) => ({
      ...item,
      slug: `/product/${item.slug}`,
    })),
);

const additionalInformation = computed(() =>
  props.product?.content?.find(
    (el: any) => el.type === 'product-series-additional-information',
  ),
);

const gallery = computed(() =>
  props.product.variations
    ?.find((variation: any) => variation.sku === props.product.sku)
    ?.images?.map((imageSrc: any) => ({
      src: imageSrc,
      alt: props.product.name,
    })),
);

return { __sfc: true,props, isBiggerSm, similarProducts, additionalInformation, gallery, ProductSeriesGallery }
}

})